import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { Observable } from 'rxjs/Observable';
import { Publicacion, Boletines } from '@app/shared';

@Injectable()
export class PublicationsDataService {

  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }



  /**
   * Metodo que devuelve todoss las publicaciones por boletin
   *
   * @param {number} id
   * @return {*}  {Observable<Publicacion[]>}
   * @memberof PublicationsDataService
   */
  getPublicaciones(id: number): Observable<Publicacion[]> {
    return new Observable(obs => {
      // this.http.skipErrorHandler().get<Publicacion[]>(this.api.get('adminPublication', [id])).subscribe(
        this.http.skipErrorHandler().get<Publicacion[]>(this.api.get('adminPublicationDetail', [id])).subscribe(
        data => {
          obs.next(data);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Metodo que consulta una publicacion por en especifico
   *
   * @param {number} id
   * @return {*}  {Observable<Publicacion[]>}
   * @memberof PublicationsDataService
   */
   getPublicacion(id: number): Observable<Publicacion[]> {
    return new Observable(obs => {
        this.http.skipErrorHandler().get<Publicacion[]>(this.api.get('adminPublication', [id])).subscribe(
        data => {
          obs.next(data);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  getBulletins(): Observable<Boletines[]> {
    return new Observable(obs => {
        this.http.skipErrorHandler().get<Boletines[]>(this.api.get('adminBulletin')).subscribe(
        data => {
          obs.next(data);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }


   /**
    * Publicar masivamente
    *
    * @param {FormData} documentClassification
    * @return {*}  {Promise<boolean>}
    * @memberof PublicationsDataService
    */
    publishMassively(publications: number[]): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.post<boolean>(this.api.get('adminPublication'), publications).subscribe(
        _resp => {
          this.toastr.success('Operación exitosa', 'Publicaciones realizadas correctamente');
          resolve(true);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   * Metodo que permite modificar una publicacion.
   *
   * @param {number} id
   * @param {FormData} publicacion
   * @return {*}  {Promise<boolean>}
   * @memberof PublicationsDataService
   */
  updatePublicaction(id: number, publicacion: FormData): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.put<boolean>(this.api.get('adminPublication', [id]), publicacion).subscribe(
        _resp => {
          this.toastr.success('Operación exitosa', 'Publicación modificada correctamente');
          resolve(true);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   * Metodo que permite eliminar un registro de publicaciones
   *
   * @param {number} id
   * @return {*}  {Promise<boolean>}
   * @memberof ManagementRolAppsDataService
   */
  deletePublicaction(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().delete<boolean>(this.api.get('adminPublication', [id])).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Publicación eliminada correctamente');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operación');
          }
          reject(err);
        }
      );
    });
  }


  /**
   * Servicio para descargar los documentos publicados
   *
   * @param {number} idDocument
   * @return {*}  {Observable<any>}
   * @memberof PublicationsDataService
   */
  dowloadFilePublicaction(id_documento_historial: number): Observable<any> {
    return new Observable(obs => {
      this.http.skipErrorHandler()
        .get(this.api.get('historyDocsInstance', [id_documento_historial]), {
          observe: 'response'
        })
        .subscribe(
          res => {
            obs.next(res.body);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              if (err.status === 500) {
                this.toastr.error('No se pudo realizar la petición al servidor.', 'Ocurrió un error');
              } else {
                this.toastr.error(err.error['message'], 'Fallo de descarga');
              }
            }
            obs.error(err);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/publications-bulletin-management/publications/shared/publications.data.service.ts